import React, { createContext, useContext, useMemo } from 'react';

// Thin seam over window.TeamforceNotifications. Kept (rather than removed)
// so tests can wrap subtrees with a custom Provider to capture/assert
// notifications, and so we can swap the underlying transport without
// touching every consumer.
const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const value = useMemo(() => ({
    addNotification: (message, type = 'success') => {
      if (typeof window !== 'undefined' && window.TeamforceNotifications) {
        window.TeamforceNotifications.show(message, type);
      } else if (typeof window !== 'undefined' && typeof window.alert === 'function') {
        window.alert(message);
      }
    },
    removeNotification: () => {
      if (typeof window !== 'undefined' && window.TeamforceNotifications) {
        window.TeamforceNotifications.clear();
      }
    },
  }), []);

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (context) return context;

  return {
    addNotification: (message, type = 'success') => {
      if (typeof window !== 'undefined' && window.TeamforceNotifications) {
        window.TeamforceNotifications.show(message, type);
      }
    },
    removeNotification: () => {},
  };
};
